<template>
  <div
    style="cursor: pointer"
    @click.prevent="$router.push({name: 'subscriptionPage'})"
  >
    <div v-if="userPackageStatus === 'ok'">
      <div v-if="userPackage.trial">
        <div class="alert alert-warning">
          {{ $t('userPackageStatusView.abunliyinizSnaqMddtiNAktivldirilib') }} <br>
          {{ $t('userPackageStatusView.paket', {name: userPackage.pack.name}) }} <br>
          {{ $t('userPackageStatusView.bitmTarixi', {expirationTime: expirationTime}) }}
        </div>
      </div>
      <div v-else-if="profile === 'PROCUREMENT'">
        <div class="alert alert-success">
          {{ $t('userPackageStatusView.paket', {name: 'Active'}) }}
        </div>
      </div>
      <div v-else-if="profile !== 'PROCUREMENT' && userPackage.pack.name === 'Standart'">
        <div class="alert alert-danger">
          {{ $t('userPackageStatusView.paket', {name: 'Standart'}) }}
        </div>
      </div>
      <div v-else>
        <div class="alert alert-success">
          {{ $t('userPackageStatusView.paket', {name: userPackage.pack.name}) }} <br>
          {{ $t('userPackageStatusView.bitmTarixi', {expirationTime: expirationTime}) }}
        </div>
      </div>
    </div>
    <div v-else-if="userPackageStatus === 'cancelled_package'">
      <div class="alert alert-danger">
        {{
          $t('userPackageStatusView.abunliyiniziDayandrmsnzLakinTarixindkPaketinQalmLi', {
            expirationTime: expirationTime,
            name: userPackage.pack.name
          })
        }}
      </div>
    </div>
    <div v-else-if="userPackageStatus === 'expired_package'">
      <div class="alert alert-danger">
        {{ $t('userPackageStatusView.abunliyinizTarixindBitib', {expirationTime: expirationTime}) }}
      </div>
    </div>
    <div v-else-if="userPackageStatus === 'no_package'">
      <div class="alert alert-danger">
        {{ $t('userPackageStatusView.sizBuProfilNPaketSeimiEtmmisiniz') }}
      </div>
    </div>
    <div v-else-if="userPackageStatus === 'no_active_package'">
      <div class="alert alert-danger">
        {{ $t('userPackageStatusView.sizinBuProfilNAktivPaketinizYoxdur') }}
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import moment from "moment";

export default {
  name: 'UserPackageStatusView',

  mounted() {

  },

  computed: {

    ...mapState({
      profile: state => state.auth.profile,
      userPackage: state => state.auth.userPackage,
      userPackageStatus: state => state.auth.userPackageStatus,
    })
    ,
    expirationTime() {
      if (this.userPackage !== null) {
        return moment(this.userPackage.expirationTime).format("DD MMM YYYY HH:mm")
      }
      return '-';
    }
  }

}
</script>
